import React, { ReactNode } from 'react'

interface ScrollableListProps {
    /** List items to render */
    children: ReactNode
    /** Maximum height before scrolling (default: max-h-96) */
    maxHeight?: string
    /** Additional className */
    className?: string
}

const ScrollableList: React.FC<ScrollableListProps> = ({
    children,
    maxHeight = 'max-h-96',
    className = '',
}) => {
    return (
        <div
            className={`mt-2 bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden ${className}`}
        >
            <div
                className={`divide-y divide-gray-100 ${maxHeight} overflow-y-auto`}
            >
                {children}
            </div>
        </div>
    )
}

export default ScrollableList
